<template>
  <section class="container-fluid">
    <router-view></router-view>
  </section>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
@import "./assets/styles/index.scss";
</style>

